import React from 'react';
import { FlaskConical, Droplet, Clock } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ComoFunciona() {
  const revealRef = useScrollReveal();
  return <section id="como-funciona" className="bg-gris-oscuro py-14 sm:py-[90px] px-6" data-id="element-103">
      <div ref={revealRef} className="max-w-[1060px] mx-auto reveal" data-id="element-104">
        <div className="text-center" data-id="element-105">
          <span className="text-[11px] tracking-[5px] uppercase text-oro mb-4 block" data-id="element-106">
            El proceso paso a paso
          </span>
          <h2 className="font-playfair text-[clamp(28px,4.5vw,52px)] font-bold leading-[1.15] mb-6" data-id="element-107">
            Así funciona{' '}
            <em className="italic text-oro-claro" data-id="element-108">El Método Italiano™</em>
          </h2>
          <div className="w-[60px] h-[2px] bg-gradient-to-r from-oro to-transparent mx-auto my-5" data-id="element-109"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-14" data-id="element-110">
          <div className="text-center p-10 border border-oro/15 rounded-md relative bg-carbon transition-colors duration-300 hover:border-oro/50" data-id="element-111">
            <div className="font-montserrat text-[56px] font-black text-oro/40 leading-none mb-3" data-id="element-112">
              01
            </div>
            <FlaskConical className="text-oro mx-auto mb-4" size={28} data-id="element-113" />
            <h3 className="text-[17px] font-bold mb-3" data-id="element-114">
              Etapa 1 — Mezcla Maestra
            </h3>
            <p className="text-[13px] text-white/60 leading-[1.7]" data-id="element-115">
              Aprendes a combinar harinas sin gluten en proporciones exactas.
              Cada combinación tiene un propósito: textura, color, elasticidad.
              No hay improvisación.
            </p>
          </div>
          <div className="text-center p-10 border border-oro/15 rounded-md relative bg-carbon transition-colors duration-300 hover:border-oro/50" data-id="element-116">
            <div className="font-montserrat text-[56px] font-black text-oro/40 leading-none mb-3" data-id="element-117">
              02
            </div>
            <Droplet className="text-oro mx-auto mb-4" size={28} data-id="element-118" />
            <h3 className="text-[17px] font-bold mb-3" data-id="element-119">
              Etapa 2 — Hidratación de Precisión
            </h3>
            <p className="text-[13px] text-white/60 leading-[1.7]" data-id="element-120">
              El agua no se "agrega al gusto". Controlamos la hidratación al
              gramo. Es la diferencia entre masa que se trabaja y masa que se
              rompe.
            </p>
          </div>
          <div className="text-center p-10 border border-oro/15 rounded-md relative bg-carbon transition-colors duration-300 hover:border-oro/50" data-id="element-121">
            <div className="font-montserrat text-[56px] font-black text-oro/40 leading-none mb-3" data-id="element-122">
              03
            </div>
            <Clock className="text-oro mx-auto mb-4" size={28} data-id="element-123" />
            <h3 className="text-[17px] font-bold mb-3" data-id="element-124">
              Etapa 3 — Reposo Estructurado
            </h3>
            <p className="text-[13px] text-white/60 leading-[1.7]" data-id="element-125">
              Los almidones necesitan tiempo para activarse. Te enseñamos
              cuánto, a qué temperatura y por qué. Este paso separa la pasta del
              pan sin gluten.
            </p>
          </div>
        </div>
      </div>
    </section>;
}